import { cx } from '@emotion/css';
import { Col } from 'antd';
import { MFormCurrencyField, MFormTextField, MTypography } from 'src/lib';
import { Color, Display, FlexDirection, Image } from 'src/styles';

import * as Styles from '../../NewTransfer.styles';

const withdrawalPolicyText = (
  <div>
    <MTypography variant='body2' testId='money-transfer-text-withdrawal-policy'>
      Once you confirm your transaction, you will be able to cancel it in the time span that the transaction is pending.
      The amount requested to be withdrawn will typically take 1 to 2 business days to be deposited in your chosen bank
      account.
    </MTypography>
    <MTypography variant='body2'>
      Once the transaction goes through, it will be deducted from your account value.
    </MTypography>
  </div>
);

const depositPolicyText = (
  <div>
    <MTypography variant='body2' testId='money-transfer-text-deposit-policy'>
      Once you confirm your transaction, you will be able to cancel it in the time span that the transaction is pending.
      Once the transaction goes through, you will be able to invest.
    </MTypography>
  </div>
);

export interface NewTransferConfirmStepProps {
  type: 'deposit' | 'withdrawal';
  amount: string;
  accountNumber?: string;
  selectedBankAccount: any;
}

export const NewTransferConfirmStep = ({
  amount,
  selectedBankAccount,
  type,
  accountNumber,
}: NewTransferConfirmStepProps) => {
  const renderSelectedBankAccountType = () => (
    <>
      <span>{selectedBankAccount.tradingBlockACHRelationship.bankAccountType}</span>
      {selectedBankAccount.tradingBlockACHRelationship.nickName && (
        <MTypography
          variant='body2'
          inline
          color={Color.Gray6}>{` (${selectedBankAccount.tradingBlockACHRelationship.nickName})`}</MTypography>
      )}
    </>
  );

  const renderSelectedBankAccount = () => (
    <Col span={24} className={cx(Display.flex, FlexDirection.column)}>
      <div>
        {selectedBankAccount.tradingBlockACHRelationship.bankName}{' '}
        <img
          alt='bankLogo'
          src={
            selectedBankAccount.tradingBlockPlaidInstitution?.logo
              ? `data:image/jpeg;base64,${selectedBankAccount?.tradingBlockPlaidInstitution?.logo}`
              : Image.BankPlaceholder
          }
          className={Styles.bankLogo}
        />
      </div>
      <div>{selectedBankAccount.tradingBlockACHRelationship?.bankAccount} </div>
    </Col>
  );

  return (
    <div>
      <Col span={24}>
        <MFormTextField
          label={
            <Col span={24} className={cx(Display.flex, FlexDirection.column)}>
              <div className={Styles.senderReceiverTopLabel}>FROM</div>
              <div>{type === 'deposit' ? renderSelectedBankAccountType() : 'My IPO'}</div>
            </Col>
          }
          value={type === 'deposit' ? renderSelectedBankAccount() : accountNumber}
        />
      </Col>

      <Col span={24}>
        <MFormTextField
          label={
            <Col span={24} className={cx(Display.flex, FlexDirection.column)}>
              <div className={Styles.senderReceiverTopLabel}>TO</div>
              <div>{type === 'deposit' ? 'My IPO' : renderSelectedBankAccountType()}</div>
            </Col>
          }
          value={type === 'deposit' ? accountNumber : renderSelectedBankAccount()}
        />
      </Col>

      <Col span={24}>
        <MFormCurrencyField label='AMOUNT' value={Number(amount)} testId={'money-transfer-amount'} />
      </Col>

      <Col span={24}>
        <MTypography variant='body2' color={Color.Gray6} className={Styles.sectionTitle}>
          POLICY
        </MTypography>
        <div className={Styles.policyText}>
          {type === 'deposit' ? depositPolicyText : withdrawalPolicyText}
          <MTypography variant='body2' inline>
            You can read more on transaction policies in the
          </MTypography>
          <a
            href={`/faq/#${'Account Information'.toLowerCase().replace(/\s/g, '')}`}
            style={{
              color: Color.Brand5,
            }}
            target='_blank'
            rel='noreferrer'>
            {' Bank Accounts & Funding Help Page'}
          </a>
          .
        </div>
      </Col>
    </div>
  );
};
